import { getFontSizes } from './helper';

export const defaultTheme = {
  colors: {
    base: {
      primary: '#008cff',
      secondary: '',
    },
    text: {
      primary: '#000',
      secondary: '',
    },
    button: {
      primary: {
        bg: 'linear-gradient(93deg, #53b2fe, #065af3)',
        text: '#ffffff',
        border: '#008cff',
        color: '#008cff',
        bg2: '#CCE8FF',
      },
      updateBtn: {
        bg: '#008cff',
      },
      secondary: {
        bg: '#ffffff',
        text: '#065af3',
      },
      topNav: {
        bg: 'linear-gradient(93deg, #53b2fe, #065af3)',
        text: '#ffffff',
      },
    },
    label: {
      primary: '#008cff',
      secondary: '',
    },
    link: {
      primary: '#008cff',
      secondary: '#008cff',
    },
    slider: {
      track: '#008cff',
    },
    topNav: '#0a223d',
    overlays: {
      topNavForm: 'rgba(255, 255, 255, 0.1)',
    },
    bodyBG: '#fff',
    bodyBGListing: '#f2f2f2',
    topnavInput: '#ffffff',
    agentInputBG: 'rgba(255, 255, 255, 0.1)',
    agentSearchIconBG: '#008cff',
    exploreLinksColor: '#FFFFFF',
  },
  font: {
    urls: ['https://fonts.googleapis.com/css?family=Lato:300,400,400i,700,900&display=swap'],
    family: "'Lato', sans-serif",
    size: {
      main: getFontSizes(),
      pageHeader: '40px',
      heading: '32px',
      subHeading: '16px',
      button: getFontSizes('12px', '16px', '18px', '20px'),
    },
    weight: '900',
    headings: {
      fontFamily: "'Lato', sans-serif",
    },
  },
  images: {
    logo: '',
    mainBg: '',
  },
  radius: {
    button: {
      topNav: '34px',
      primary: '34px',
      secondary: '34px',
    },
  },
  cards: {
    packageType: {
      fontSize: '10px',
    },
    packageName: {
      fontSize: '16px',
    },
    destinationInfo: {
      fontSize: '18px',
    },
    dayNightInfoLabel: {
      bgColor: '#000000',
      color: '#ffffff',
    },
    includes: {
      fontSize: '12px',
    },
    sightSeeing: {
      fontSize: '14px',
    },
    priceActual: {
      fontSize: '12px',
    },
    priceCurrent: {
      fontSize: '22px',
    },
    bottomInfoSection: {
      fontSize: '12px',
    },
    badge: {
      color: '#BB8A11',
      bgColor: '#FFEDD1',
      fontSize: '10px',
    },
  },
  topNav: {
    inputContainerBorder: 'none',
  },
  detailsPage: {
    leftContainer: {
      boxShadow: '0 2px 30px 0 rgba(0, 0, 0, 0.1)',
    },
    mainNav: {
      fontSize: '16px',
      fontWeight: '900',
    },
    itineraryNav: {
      bgColor: '#ECF7FF',
      marginBottom: '0',
      tab: {
        color: '#4a4a4a',
        bgColor: 'transparent',
        active: {
          bgColor: '#ffffff',
          color: '#008CFF',
        },
      },
    },
    dayplan: {
      bgColor: '#FFF',
      title: {
        bg: 'linear-gradient(87deg, #f4d1ca 15%, #e2d9b2 100%)',
        bg2: 'linear-gradient(67deg, #ff7f3f 0%, #ff3e5e 100%)',
        color: '#000000',
      },
      flightUpgradeRow: {
        bg: 'linear-gradient(87deg, #ffc46880, #fdd9a180 100%)',
        margin: '10px 18px',
        borderRadius: '4px',
      },
    },
    rightContainer: {
      topHeader: {
        bg: '#eaf5ff',
        badge: {
          bg: 'linear-gradient(247deg, #ff3e5e, #ff6d3f)',
        },
      },
    },
  },
  thankyouPage: {
    topHeaderColor: '#000',
    bg: 'linear-gradient(73deg, #4affcd, #7dbfcc)',
  },
  reviewPage: {
    bgColor: '#0a223d',
    navColor: '#9b9b9b',
  },
};
